import "../styles/App.css";
import * as React from "react";
import AppLayout from "./AppLayout";
import NavigationProvider from "../features/navigation/NavigationProvider";
import PrefillProvider from "../features/unlinked-application/components/PrefillProvider";
import RouteLoading from "./RouteLoading";
import Routes from "../Routes";
import { appReady } from "../features/bootstrap/bootstrapSlice";
import { onLoad } from "../messages";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import useAuthSucces from "../hooks/useAuthSuccess";
import { useGetIssuersQuery } from "../services/savvy";
import { useLocation } from "react-router-dom";
import useMemoryHistory from "../hooks/useMemoryHistory";
import useSelectedIssuerNextRoute from "../features/applicant/useSelectedIssuerNextRoute";
import useTrellisWindowEventListener from "../hooks/useTrellisWindowEventListener";
export default function App() {
    var accountInfo = useAppSelector(function (state) { return state.auth.auto.accountInfo; });
    var ready = useAppSelector(function (_a) {
        var bootstrap = _a.bootstrap;
        return bootstrap.ready;
    });
    var validatedPreSelectedIssuer = useAppSelector(function (_a) {
        var bootstrap = _a.bootstrap;
        return bootstrap.validatedPreSelectedIssuer;
    });
    useGetIssuersQuery();
    var location = useLocation();
    var getSelectedIssuerNextRoute = useSelectedIssuerNextRoute();
    var push = useMemoryHistory().push;
    var dispatch = useAppDispatch();
    useTrellisWindowEventListener();
    useAuthSucces();
    // only fire this once, do not re-fire when account info changes
    React.useEffect(function () {
        onLoad({ accountInfo: accountInfo });
    }, []); // eslint-disable-line
    /**
     * If the app is not ready but we have validated the pre selected issuer
     * that means we need to wait for the proper route to be navigated to
     * in order to avoid an intial page transition from the selected issuer route
     * to the proper location.
     */
    React.useEffect(function () {
        if (!ready && validatedPreSelectedIssuer) {
            var nextRoute = getSelectedIssuerNextRoute();
            if (nextRoute && nextRoute !== location.pathname) {
                push(nextRoute);
            }
            dispatch(appReady());
        }
    }, [
        ready,
        validatedPreSelectedIssuer,
        getSelectedIssuerNextRoute,
        location.pathname,
        dispatch,
        push,
    ]);
    return (React.createElement(PrefillProvider, null,
        React.createElement(NavigationProvider, null,
            React.createElement(AppLayout, null,
                React.createElement(React.Suspense, { fallback: React.createElement(RouteLoading, null) },
                    React.createElement(Routes, null))))));
}
